module.exports = __webpack_public_path__ + "static/media/beach.4f26d8ff.svg";